import {isTossRuntime,publicShareOrigin} from './platform';
/** 키 fragment는 토스 링크 생성 API에 전달하지 않는다. */
export async function hintShareUrl(raw:string,options?:{toss?:boolean;createLink?:(path:string)=>Promise<string>}){
 const url=new URL(raw);if(url.origin!==publicShareOrigin()||!['/brief','/hint/answer'].includes(url.pathname)||!url.hash)throw new Error('SG-E411');
 if(!(options?.toss??isTossRuntime()))return url.href;
 const create=options?.createLink??(async(path:string)=>{const {getTossShareLink}=await import('@apps-in-toss/web-framework');return getTossShareLink(path)});
 const deepLink=`intoss://seonmulgam${url.pathname}${url.search}`;
 const result=new URL(await create(deepLink));if(result.protocol!=='https:'||result.hash)throw new Error('SG-E411');result.hash=url.hash;return result.href;
}
